/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DetachAuthClientFromMcpServerRequestBody,
  DetachAuthClientFromMcpServerRequestBody$Outbound,
  DetachAuthClientFromMcpServerRequestBody$outboundSchema,
} from "../components/detachauthclientfrommcpserverrequestbody.js";

export type DetachAuthClientFromMcpServerSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type DetachAuthClientFromMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  detachAuthClientFromMcpServerRequestBody:
    DetachAuthClientFromMcpServerRequestBody;
};

/** @internal */
export type DetachAuthClientFromMcpServerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const DetachAuthClientFromMcpServerSecurity$outboundSchema:
  z.ZodMiniType<
    DetachAuthClientFromMcpServerSecurity$Outbound,
    DetachAuthClientFromMcpServerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function detachAuthClientFromMcpServerSecurityToJSON(
  detachAuthClientFromMcpServerSecurity: DetachAuthClientFromMcpServerSecurity,
): string {
  return JSON.stringify(
    DetachAuthClientFromMcpServerSecurity$outboundSchema.parse(
      detachAuthClientFromMcpServerSecurity,
    ),
  );
}

/** @internal */
export type DetachAuthClientFromMcpServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  DetachAuthClientFromMcpServerRequestBody:
    DetachAuthClientFromMcpServerRequestBody$Outbound;
};

/** @internal */
export const DetachAuthClientFromMcpServerRequest$outboundSchema: z.ZodMiniType<
  DetachAuthClientFromMcpServerRequest$Outbound,
  DetachAuthClientFromMcpServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    detachAuthClientFromMcpServerRequestBody:
      DetachAuthClientFromMcpServerRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      detachAuthClientFromMcpServerRequestBody:
        "DetachAuthClientFromMcpServerRequestBody",
    });
  }),
);

export function detachAuthClientFromMcpServerRequestToJSON(
  detachAuthClientFromMcpServerRequest: DetachAuthClientFromMcpServerRequest,
): string {
  return JSON.stringify(
    DetachAuthClientFromMcpServerRequest$outboundSchema.parse(
      detachAuthClientFromMcpServerRequest,
    ),
  );
}
